import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isTokenExpired, handleSessionExpired } from "../service/register.service";

/**
 * Route Guard for protected pages (e.g. /admin, /payment).
 * Prevents mounting protected views when unauthenticated or when the JWT has expired.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.requiredRole] - Optional required authority, e.g. "ROLE_ADMIN"
 */
const ProtectedRoute = ({ children, requiredRole }) => {
    const location = useLocation();
    const token = localStorage.getItem("ivec_token");
    const role = localStorage.getItem("ivec_role");

    // 1. No token present -> redirect to login
    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 2. Token present but expired -> trigger session expired flow cleanly
    if (isTokenExpired(token)) {
        handleSessionExpired({ silent: true });
        return <Navigate to="/login?sessionExpired=true" replace />;
    }

    // 3. Role-based access control (e.g. non-admin trying to access /admin)
    if (requiredRole && role !== requiredRole) {
        return <Navigate to="/payment" replace />;
    }

    return children;
};

export default ProtectedRoute;

